const i18CustomParams = function () {
  // Из соображений производительности, i18 подключается отдельно к нужным пакам, а не ко всему проекту
  return {
    lng: 'ru',
    resources: {
      ru: {
        translation: {
          nightCount_0: '{{count}} ночь',
          nightCount_1: '{{count}} ночи',
          nightCount_2: '{{count}} ночей',

          sutki_0: 'сутки',
          sutki_1: 'суток',
          sutki_2: 'суток',

          dayCount_0: '{{count}} день',
          dayCount_1: '{{count}} дня',
          dayCount_2: '{{count}} дней',

          adult_0: 'взрослый',
          adult_1: 'взрослых',
          adult_2: 'взрослых',

          child_0: 'ребенок',
          child_1: 'ребенка',
          child_2: 'детей',

          variant_0: 'Доступен {{count}} вариант',
          variant_1: 'Доступно {{count}} варианта',
          variant_2: 'Доступно {{count}} вариантов',

          variant_chosen_0: 'Выбран {{count}} вариант',
          variant_chosen_1: 'Выбрано {{count}} варианта',
          variant_chosen_2: 'Выбрано {{count}} вариантов',

          variant_found_0: 'Нашли {{count}} вариант',
          variant_found_1: 'Нашли {{count}} варианта',
          variant_found_2: 'Нашли {{count}} вариантов',

          for_guest_0: 'для {{count}} гостя',
          for_guest_1: 'для {{count}} гостей',
          for_guest_2: 'для {{count}} гостей',

          guest_0: '{{count}} гость',
          guest_1: '{{count}} гостя',
          guest_2: '{{count}} гостей',

          age_0: 'Менее {{count}} года',
          age_1: '{{count}} года',
          age_2: '{{count}} лет',

          bonus_0: '{{count}} бонус',
          bonus_1: '{{count}} бонуса',
          bonus_2: '{{count}} бонусов',

          bonus_from_0: 'от {{count}} бонуса',
          bonus_from_1: 'от {{count}} бонусов',
          bonus_from_2: 'от {{count}} бонусов',

          full_bonus_0: 'бонусный балл',
          full_bonus_1: 'бонусных балла',
          full_bonus_2: 'бонусных баллов',

          remaining_symbol_0: 'Остался {{count}} символ',
          remaining_symbol_1: 'Осталось {{count}} символа',
          remaining_symbol_2: 'Осталось {{count}} символов',

          bookings_0: '{{count}} бронирование',
          bookings_1: '{{count}} бронирования',
          bookings_2: '{{count}} бронирований',

          arrival_0: '{{count}} заезд',
          arrival_1: '{{count}} заезда',
          arrival_2: '{{count}} заездов',

          additional_seats_0: '{{count}} доп. место',
          additional_seats_1: '{{count}} доп. места',
          additional_seats_2: '{{count}} доп. мест',

          base_seats_0: '{{count}} основное',
          base_seats_1: '{{count}} основных',
          base_seats_2: '{{count}} основных',

          articles_0: '{{count}} статья',
          articles_1: '{{count}} статьи',
          articles_2: '{{count}} статей',

          categories_0: '{{count}} раздел',
          categories_1: '{{count}} раздела',
          categories_2: '{{count}} разделов',

          star_0: '{{count}} звезда',
          star_1: '{{count}} звезды',
          star_2: '{{count}} звезд',

          room_0: '{{count}} номер',
          room_1: '{{count}} номера',
          room_2: '{{count}} номеров',
        },
      },
    },
  };
};

export default i18CustomParams;
